'use strict';

var _ = require('lodash');
var moment = require('moment');
var SeasonLabelFormattingService = function SeasonLabelFormattingService() {
  var SEASONS_ABBREVIATIONS = {
    '^Off(\\-|\\s)?Peak': 'O-Pk.',
    '^Super(\\-|\\s)?Peak': 'S-Pk.',
    '^Shoulder': 'Sh.',
    '^Peak': 'Pk.'
  };
  var SEASONS_LABELS = {
    '^O\\-Pk.': 'Off-Peak',
    '^S\\-Pk.': 'SuperPeak',
    '^Sh\\.': 'Shoulder',
    '^Pk\\.': 'Peak'
  };
  var WEEKDAYS_ABBREVIATIONS = function () {
    var weekdaysShort = moment.weekdaysShort();
    return _.reduce(moment.weekdays(), function (days, day, index) {
      days[day] = weekdaysShort[index];
      return days;
    }, {});
  }();
  var WEEKDAYS_LABELS = _.chain(WEEKDAYS_ABBREVIATIONS).invert().transform(function (result, weekday, weekDayAbbr) {
    result[weekDayAbbr + '$'] = weekday;
    return result;
  }, {}).value();
  function formatSeasonLabel(srcLabel, abbreviations) {
    if (srcLabel === 'undefined') {
      return 'N/A';
    } else {
      return _.reduce(abbreviations, function (label, longValue, abbreviation) {
        return label.replace(new RegExp(abbreviation, 'i'), longValue);
      }, srcLabel).toUpperCase();
    }
  }
  function formatSeasonLabels(data) {
    var abbreviations = _.merge(SEASONS_ABBREVIATIONS, WEEKDAYS_ABBREVIATIONS);
    return _.transform(data, function (result, entry) {
      var stringMode = _.isString(entry);
      if (stringMode) {
        entry = formatSeasonLabel(entry, abbreviations);
      } else {
        entry.label = formatSeasonLabel(entry.label, abbreviations);
      }
      return result.push(entry);
    });
  }
  function formatSeasonFilter(sLabel) {
    if (_.isNil(sLabel)) {
      return sLabel;
    }
    if (sLabel === 'N/A') {
      return undefined;
    }
    var label = sLabel;
    var seasonsKeys = Object.keys(SEASONS_LABELS);
    for (var i = 0, len = seasonsKeys.length; i < len; i++) {
      var key = seasonsKeys[i];
      WEEKDAYS_LABELS[key] = SEASONS_LABELS[key];
    }
    var weekdaysKeys = Object.keys(WEEKDAYS_LABELS);
    for (var j = 0, length = weekdaysKeys.length; j < length; j++) {
      var currentKey = weekdaysKeys[j];
      var unformatedLabel = WEEKDAYS_LABELS[currentKey];
      label = label.replace(new RegExp(currentKey, 'i'), unformatedLabel);
    }
    return label;
  }
  return {
    formatSeasonLabels: formatSeasonLabels,
    formatSeasonFilter: formatSeasonFilter
  };
};
module.exports = SeasonLabelFormattingService;